import { Component, Input, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { fadeInOut } from '../../animations/animations';
import { IPendingTransaction } from '../../interfaces/pending-transaction.interface';
import { TransactionsState } from '../../states/transactions/transactions.state';

@Component({
  selector: 'app-pending-transaction-message',
  templateUrl: './pending-transaction-message.component.html',
  styleUrls: ['../wholesaler-result-message/wholesaler-result-message.component.scss', './pending-transaction-message.component.scss'],
  animations: [fadeInOut],
})
export class PendingTransactionMessageComponent implements OnInit {

  @Select(TransactionsState.pendingTransactions) pendingTransactions$: Observable<IPendingTransaction[]>;
  @Input() show: boolean;
  
  constructor() { }

  ngOnInit(): void {
  }

}
